import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { TimelineMax } from "gsap";
import "./layout.css";
import "./typography.css";

const Sidebar = function() {
  const [toggle, setToggle] = useState(false);
  const [tl] = useState(new TimelineMax({ paused: true }));

  let tweenTarget = null;

  const toggleTimeline = () => {
    setToggle(!toggle);
  };

  useEffect(() => {
    tl.to("#btn-sidebar", 0.01, {
      rotation: 45,
      scale: 1.15,
    })
      .to(tweenTarget, 0.01, { display: "block" })
      .from(tweenTarget, 0.5, { x: 500 })
      .to(tweenTarget, 0.5, { x: 16 })
      .staggerFrom(".sidebar-row", 0.3, { x: 500, opacity: 0 }, 0.03)
      .reverse();
  }, [tl, tweenTarget]);

  useEffect(() => {
    tl.reversed(!toggle);
  }, [tl, toggle]);

  let hamburgerIcon = (
    <svg
      height="32"
      width="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ic menu 28px</title>
      <rect
        height="32"
        width="32"
        fill="#303034"
        rx="3"
        ry="3"
        stroke="none"
        x="0"
        y="0"
        data-element="frame"
      />
      <g
        fill="#f6efe4"
        transform="translate(4.800000000000001 4.800000000000001) scale(.95)"
      >
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
      </g>
    </svg>
  );

  return (
    <div id="sidebar-outer-container">
      <div className="global-layout-controls">
        <button
          id="btn-sidebar"
          className="btn-toggle"
          onClick={() => {
            toggleTimeline();
          }}
        >
          {hamburgerIcon}
        </button>
      </div>

      <div
        className="Sidebar hidden"
        id="sidebar-row"
        ref={(e) => (tweenTarget = e)}
      >
        <h3 className="menu-id">Menu</h3>
        <div className="secondary-navlinks">
          <h3 className="sidebar-row">
            <Link
              to="/"
              onClick={() => {
                toggleTimeline();
              }}
            >
              Hi! I'm Julian.
            </Link>
          </h3>

          <h3 className="sidebar-row">
            <Link
              to="/college/"
              onClick={() => {
                toggleTimeline();
              }}
            >
              Case Studies
            </Link>
            <Link
              className="circled"
              to="/college/"
              onClick={() => {
                toggleTimeline();
              }}
            >
              1
            </Link>
            <Link
              className="circled"
              to="/nise/"
              onClick={() => {
                toggleTimeline();
              }}
            >
              2
            </Link>
            <Link
              className="circled"
              to="/impakt/"
              onClick={() => {
                toggleTimeline();
              }}
            >
              3
            </Link>
          </h3>

          {/* <h3 className="sidebar-row">
            <a href="/designprocess.pdf">How I work</a>
          </h3> */}

          <h3 className="sidebar-row">
            <a href="/resume.pdf">Resume</a>
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
